import queryStringParams from '../../services/queryStringParams';

export default function() {
  return !!queryStringParams.get('demo');
};



// WEBPACK FOOTER //
// ./src/services/demoMode/demoMode.js